import { useNavigate } from "react-router-dom";
import "./ClientRegister.css";

const ClientRegister = () => {
  const navigate = useNavigate();

  const handleStartRegistration = () => {
    localStorage.setItem("portalType", "registration");
    navigate("/client/registration/user-agreement");
  };

  return (
    <div className="content-container">
      <div className="text-container">
        <div style={{ display: "flex" }}>
          <div style={{ width: "100%" }}>
            <h1>New Client Registration</h1>
          </div>
          {/* <div className="pop-up-warning">
            ⚠️ Application maintenance is in progress.  You can continue to use
            the application but may experience slower performance during this
            time.
          </div> */}
          {/* <div className="pop-up-error">
            🚫 We’re performing a scheduled update. Please try again later.
          </div> */}
          <div className="logo-help-wrapper">
            <button
              className="help-icon-button"
              onClick={() => navigate("/help")}
              aria-label="Help"
            >
              <i className="bi bi-question-circle"></i>
            </button>
          </div>
        </div>
        <div className="divider"></div>
        <div className="text-body">
          Thank you for choosing Oxford Document Management for your screening
          needs! The registration process can be completed in a matter of 5-10
          minutes, and consists of four simple steps.
        </div>
        <br></br>
        <div className="text-header">Step 1: Accept User Agreement</div>
        <div className="text-body">
          Read and accept our "User Agreement" which describes our respective
          duties and obligations.
        </div>
        <div className="text-header">Step 2: Provide Key Information</div>
        <div className="text-body">
          Provide us with key and necessary information about your organization.
        </div>
        <div className="text-header">Step 3: Define Position Codes</div>
        <div className="text-body">
          It is here you can define for us in advance the services you wish us
          to perform for certain types of positions. You can accept the default
          Position Codes provided or create your own (quick and easy).
        </div>
        <div className="text-header">Step 4: Print Confirmation Page</div>
        <div className="text-body">
          Print for your records a Confirmation Page summarizing the data
          entered and options chosen in the previous steps. Also included are
          simple instructions on how to order services from Oxford Document
          Management in the future. A one time $50 set up fee will be billed
          when the first background check is initiated using your unique client
          number/abbreviation.
        </div>
        <br></br>
        <div className="text-body">
          If you have questions or need help at any stage in the set-up process,
          please feel free to call us at 800-801-9114. We would be happy to
          assist you.
        </div>
        <br></br>
        <div className="error">
          If you exit this process or refresh before completing all the steps,
          your data will not be saved.
        </div>
        <br></br>
        <button onClick={handleStartRegistration} className="oxbtn btn-purple">
          Start the Registration Process
        </button>
      </div>
    </div>
  );
};

export default ClientRegister;
